import config from '@config/seo_meta.json'
import Image from 'next/image'
import Link from 'next/link'
interface Props {
  slice: any
}

const TileBlock = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const items = slice?.items
  return (
    <div className="flex w-full flex-col gap-8 pb-16  lg:gap-10 lg:pb-20">
      <div className="heading-mobile-3 lg:heading-3 text-dark-grey">
        {title}
      </div>
      <div className="grid grid-cols-4 gap-x-6 gap-y-8 lg:grid-cols-12 lg:gap-x-8 lg:gap-y-12">
        {items?.map((item: any, index: number) => {
          const title = item?.title
          const description = item?.description
          const imageUrl = item?.image?.url
          const alt = item?.image?.alt
          const link = item?.link
          return link ? (
            <Link
              key={index}
              className={`col-span-4 flex flex-col gap-6`}
              href={link}
            >
              <div className="relative aspect-square w-full">
                <Image
                  fill
                  style={{ objectFit: 'cover' }}
                  src={imageUrl || '/product-img-placeholder.svg'}
                  alt={alt || config.openGraph.images[0].alt}
                />
              </div>
              <div className="flex flex-col gap-2">
                {title && (
                  <div className="heading-mobile-4 lg:heading-4 text-dark-grey">
                    {title}
                  </div>
                )}
                {description && (
                  <div className="body-1 text-dark-grey">{description}</div>
                )}
              </div>
            </Link>
          ) : (
            <div key={index} className="col-span-4 flex flex-col gap-6">
              <div className="relative aspect-square w-full">
                <Image
                  fill
                  style={{ objectFit: 'cover' }}
                  src={imageUrl || '/product-img-placeholder.svg'}
                  alt={alt || config.openGraph.images[0].alt}
                />
              </div>
              <div className="flex flex-col gap-2">
                {title && (
                  <div className="heading-mobile-4 lg:heading-4 text-dark-grey">
                    {title}
                  </div>
                )}
                {description && (
                  <div className="body-1 text-dark-grey">{description}</div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TileBlock
